import { Row } from "reactstrap";
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";

function UserCreditsView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Financiamiento', href: '' }
    ]; 

	return (
        <MainPageComponent requireAuthentication={true} path={breadcrumbPath} >
            <CenterCenterVerticalContainer>
                <Row>
                    <h1>Financiamientos</h1>
                </Row>
            </CenterCenterVerticalContainer>
        </MainPageComponent>
	);
}

export default UserCreditsView;